import React from "react";
import { Link } from "react-router-dom";
import { __ } from "services/Translator";

export default function Cashback(props) {
  return (
    <div className="cashback_bape_new">
      <section className="cashback_banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="banner_headline">{__("20% Weekly Cashback")}</div>
              <div className="banner_dsc">{__("Get Daily, Weekly and Monthly Cashback on your play")}</div>
              {/* <div className="banner_btn">
                <Link>{__("Get The Deal!")}</Link>
              </div> */}

              {props.isAuthenticated ? (
                <Link to="/games/live-casino" className="common_btn_v1 large ">
                  {__("Get The Deal!")}
                </Link>
              ) : (
                <>
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="common_btn_v1 large "
                  >
                    {__("Get The Deal!")}
                  </Link>
                </>
              )}
            </div>
            <div className="col-md-6">
              <div className="banner_image">
                <img src={require("../assets/images/cashback/bascback-banner-1.svg").default} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cashback_feature">
        <div className="container">
          <div className="feature_list">
            <div className="item">
              <div className="icon">
                {/* <svg
                  width="24"
                  height="36"
                  viewBox="0 0 24 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.9013 13.8675H14.3816L21.0631 1.71951C21.4389 1.03612 20.9444 0.199951 20.1645 0.199951H7.86069C7.42736 0.199951 7.04079 0.472363 6.89505 0.880469L0.0606101 20.0168C-0.177896 20.6846 0.317163 21.3871 1.02626 21.3871H10.7154L8.22348 33.9711C8.00869 35.0557 9.42612 35.6654 10.0658 34.7634L23.7376 15.4861C24.2192 14.8071 23.7337 13.8675 22.9013 13.8675Z"
                    fill="#10294F"
                  />
                </svg> */}
                1
              </div>
              <div className="title">{__("Daily Wheel")}</div>
              <div className="dsc">
                {__("Spin the wheel the day after each day you finish down for a chance to win up to 10% cashback")}
              </div>
            </div>
            <div className="item">
              <div className="icon">
                {/* <svg
                  width="35"
                  height="36"
                  viewBox="0 0 35 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M34.8829 22.1918C34.8837 22.1901 34.8831 22.1882 34.8839 22.1865C34.9977 21.9552 35.0013 21.5991 34.9379 21.4087L30.768 9.10403C30.6288 8.68547 30.2372 8.40308 29.7956 8.40308H28.7702V6.35229H29.7956C30.3624 6.35229 30.821 5.89367 30.821 5.3269C30.821 4.76014 30.3624 4.30151 29.7956 4.30151H20.3783C20.0685 3.4328 19.3851 2.74941 18.5164 2.43961V1.22534C18.5164 0.658574 18.0578 0.199951 17.491 0.199951C16.9242 0.199951 16.4656 0.658574 16.4656 1.22534V2.43961C15.5969 2.74941 14.9135 3.4328 14.6037 4.30151H3.13553C2.56876 4.30151 2.11014 4.76014 2.11014 5.3269C2.11014 5.89367 2.56876 6.35229 3.13553 6.35229H6.2117V8.40308H5.18631C4.74471 8.40308 4.35314 8.68547 4.21396 9.10403L0.0440415 21.4087C-0.0678628 21.745 0.0646861 21.9864 0.0991392 22.1918C0.28159 22.3972 1.98757 26.8601 7.23709 26.8601C12.4893 26.8601 14.1243 22.3971 14.3067 22.1918C14.3666 22.0052 14.4761 21.7526 14.3618 21.4087L10.2602 9.10403C10.121 8.68547 9.72947 8.40308 9.28787 8.40308H8.26248V6.35229H14.6037C14.9135 7.22101 15.5969 7.90439 16.4656 8.2142V21.4908L14.523 25.3761C14.4519 25.5183 14.4148 25.6755 14.4148 25.8347V30.073C14.4148 31.7693 13.0349 33.1492 11.3387 33.1492C10.7719 33.1492 10.3133 33.6078 10.3133 34.1746C10.3133 34.7413 10.7719 35.2 11.3387 35.2H23.6433C24.2101 35.2 24.6687 34.7413 24.6687 34.1746C24.6687 33.6078 24.2101 33.1492 23.6433 33.1492C21.9471 33.1492 20.5672 31.7693 20.5672 30.073V25.8347C20.5672 25.6755 20.5301 25.5183 20.459 25.3761L18.5164 21.4908V8.2142C19.3851 7.90439 20.0685 7.22101 20.3783 6.35229H26.7195V8.40308H25.6941C25.2525 8.40308 24.861 8.68547 24.7218 9.10403L20.6202 21.4087C20.5568 21.5991 20.5604 21.9553 20.6742 22.1865C20.675 22.1882 20.6744 22.1901 20.6752 22.1918C20.8578 22.3972 22.4953 26.8601 27.7448 26.8601C32.9972 26.8601 34.7005 22.3971 34.8829 22.1918ZM6.2117 20.7078H2.43867L5.92527 10.4539H6.21163V20.7078H6.2117ZM8.54884 10.4539L11.9671 20.7078H8.26241V10.4539H8.54884ZM26.7195 20.7078H23.0148L26.4331 10.4539H26.7194V20.7078H26.7195ZM28.7703 20.7078V10.4539H29.0567L32.5433 20.7078H28.7703Z"
                    fill="#10294F"
                  />
                </svg> */}
                2
              </div>
              <div className="title">{__("Weekly Cashback")}</div>
              <div className="dsc">
                {__("Finish the week $250 or more down and get 10% cashback automatically every Monday")}
              </div>
            </div>
            <div className="item">
              <div className="icon">
                {/* <svg
                  width="42"
                  height="36"
                  viewBox="0 0 42 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.4277 9.39429L22.7227 33.7937L41.3432 9.39429H30.4277Z"
                    fill="#10294F"
                  />
                  <path
                    d="M6.0021 0.763916L0.0869141 7.86215H10.1427L6.0021 0.763916Z"
                    fill="#10294F"
                  />
                  <path
                    d="M35.3408 0.763916L31.2002 7.86215H41.256L35.3408 0.763916Z"
                    fill="#10294F"
                  />
                  <path
                    d="M10.9155 9.39453H0L18.6205 33.794L10.9155 9.39453Z"
                    fill="#10294F"
                  />
                  <path
                    d="M22.5215 0.199951L29.7056 7.38402L33.8959 0.199951H22.5215Z"
                    fill="#10294F"
                  />
                  <path
                    d="M7.44727 0.199951L11.6377 7.38402L18.8217 0.199951H7.44727Z"
                    fill="#10294F"
                  />
                  <path
                    d="M12.5225 9.39453L20.672 35.2L28.8215 9.39453H12.5225Z"
                    fill="#10294F"
                  />
                  <path
                    d="M20.6721 0.517334L13.3271 7.86226H28.017L20.6721 0.517334Z"
                    fill="#10294F"
                  />
                </svg> */}
                3
              </div>
              <div className="title">{__("Enhanced Cashback")}</div>
              <div className="dsc">
                {__(
                  "Qualify for our Gold Loyalty Tier or get invited to our VIP Program and extra Cashback each week will be yours"
                )}
              </div>
            </div>
            <div className="item">
              <div className="icon">
                {/* <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M33.9576 12.6077H32.9494V11.6193C32.9494 11.073 32.4985 10.6309 31.9413 10.6309C31.3841 10.6309 30.9332 11.073 30.9332 11.6193V12.6077H29.9251C29.3679 12.6077 28.917 13.0498 28.917 13.5962C28.917 14.1425 29.3679 14.5846 29.9251 14.5846H30.9332V15.5731C30.9332 16.1194 31.3841 16.5615 31.9413 16.5615C32.4985 16.5615 32.9494 16.1194 32.9494 15.5731V14.5846H33.9576C34.5148 14.5846 34.9657 14.1425 34.9657 13.5962C34.9657 13.0498 34.5148 12.6077 33.9576 12.6077Z"
                    fill="#10294F"
                  />
                  <path
                    d="M29.8577 8.654C30.4145 8.654 30.8658 8.21146 30.8658 7.66556C30.8658 7.11966 30.4145 6.67712 29.8577 6.67712C29.301 6.67712 28.8496 7.11966 28.8496 7.66556C28.8496 8.21146 29.301 8.654 29.8577 8.654Z"
                    fill="#10294F"
                  />
                  <path
                    d="M25.8255 14.5845C26.3823 14.5845 26.8336 14.142 26.8336 13.5961C26.8336 13.0502 26.3823 12.6077 25.8255 12.6077C25.2687 12.6077 24.8174 13.0502 24.8174 13.5961C24.8174 14.142 25.2687 14.5845 25.8255 14.5845Z"
                    fill="#10294F"
                  />
                  <path
                    d="M17.0482 24.7585C17.442 24.3724 18.08 24.3724 18.4738 24.7585L18.7692 25.0481V16.5614H16.7529V25.0481L17.0482 24.7585Z"
                    fill="#10294F"
                  />
                  <path
                    d="M27.8421 16.5614H20.7854V27.4342C20.7854 27.8338 20.5403 28.1948 20.1632 28.3473C20.0382 28.3984 19.9072 28.4226 19.7773 28.4226C19.5154 28.4226 19.2575 28.3222 19.0645 28.133L17.7611 26.8549L16.4576 28.133C16.1681 28.4168 15.7369 28.5008 15.3589 28.3473C14.9818 28.1948 14.7367 27.8338 14.7367 27.4342V16.5614H14.1715L6.67188 20.8069V33.4307C6.67188 33.977 7.12277 34.4191 7.67998 34.4191H27.8421C28.3993 34.4191 28.8502 33.977 28.8502 33.4307V17.5498C28.8502 17.0035 28.3993 16.5614 27.8421 16.5614Z"
                    fill="#10294F"
                  />
                  <path
                    d="M25.4729 6.73895L23.4569 3.31502C23.323 3.08821 23.1025 2.92215 22.8445 2.85461C22.5876 2.78799 22.311 2.82278 22.0796 2.95306L18.9781 4.70878C18.9806 4.01911 18.8138 3.27127 18.4527 2.65844C17.9142 1.74334 17.045 1.08894 16.0043 0.815733C14.9657 0.544507 13.8778 0.68348 12.9446 1.21051C11.652 1.94314 10.8792 3.30705 10.9303 4.77039L10.9372 4.97888C10.9372 4.98659 10.9372 4.99338 10.9382 5.00109L11.0367 7.92066L8.55091 6.40196C8.5499 6.40097 8.54796 6.40005 8.54695 6.39906L8.36582 6.28803C7.09783 5.51488 5.50885 5.48588 4.2143 6.21851C3.281 6.74653 2.61356 7.59882 2.33492 8.61915C2.05628 9.63948 2.1991 10.7051 2.73756 11.6202C3.10552 12.2439 3.62349 12.7288 4.21908 13.0639L1.05994 14.8143C0.577658 15.0873 0.41253 15.6918 0.690902 16.1647L2.77399 19.5889C3.05236 20.0616 3.66885 20.2236 4.15113 19.9507L25.104 8.08922C25.5862 7.81634 25.7513 7.21182 25.4729 6.73895ZM7.23742 11.3551C6.27373 11.8986 5.03894 11.5755 4.48394 10.6318C3.92773 9.68778 4.25947 8.47537 5.22228 7.931C5.86908 7.56324 6.66555 7.57866 7.29857 7.96573L10.1483 9.70728L7.23742 11.3551ZM16.9081 5.21275C16.7694 5.72192 16.4359 6.1482 15.9699 6.41172L13.0582 8.06003L12.9446 4.70278C12.92 3.97015 13.3069 3.28866 13.9527 2.92281C14.4174 2.65738 14.9608 2.58885 15.4826 2.72493C16.0024 2.86199 16.4375 3.18922 16.7063 3.64674C16.9761 4.10438 17.0479 4.70212 16.9081 5.21275Z"
                    fill="#10294F"
                  />
                </svg> */}
                4
              </div>
              <div className="title">{__("Regular Races")}</div>
              <div className="dsc">
                {__("Add to your bankroll just for playing your favourite games with our regular Races")}
              </div>
            </div>
            <div className="item">
              <div className="icon">
                {/* <svg
                  width="35"
                  height="35"
                  viewBox="0 0 35 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.0337 0.530151C8.53194 0.530151 0.829102 8.08289 0.829102 17.3992C0.829102 26.7152 8.53194 34.2689 18.0336 34.2689C27.5353 34.2689 35.2389 26.7156 35.2389 17.3992C35.2386 8.08289 27.5355 0.530151 18.0337 0.530151ZM27.8589 19.516C27.084 24.3439 22.8192 27.8 17.9832 27.8C17.4686 27.8 16.9477 27.7607 16.4236 27.6801C10.9757 26.8384 7.24043 21.808 8.09723 16.467C8.51255 13.8792 9.93069 11.6047 12.0904 10.0629C13.9496 8.73572 16.1665 8.08997 18.4316 8.19524L16.7654 6.63946L17.8574 5.51586L20.4141 7.90441L20.4146 7.90408L21.5582 8.97391L20.4671 10.0975L20.4665 10.0966L18.0306 12.6039L16.8859 11.5332L18.4293 9.94613C16.5417 9.8411 14.6896 10.3722 13.1409 11.4777C11.3664 12.7445 10.2014 14.613 9.86015 16.7391C9.15659 21.1272 12.2255 25.26 16.7011 25.9513C21.1766 26.6408 25.3913 23.6327 26.0954 19.244C26.5604 16.3471 25.3814 13.4276 23.0176 11.6247L24.1141 10.2436C26.9897 12.4371 28.4249 15.9901 27.8589 19.516ZM14.7185 20.2606L14.6598 20.1261L16.1306 19.5147L16.1887 19.6495C16.4225 20.1938 17.2311 20.6041 18.069 20.6041C18.4457 20.6041 19.6743 20.5368 19.6743 19.6663C19.6743 19.2104 19.1489 18.9375 18.0209 18.807C16.755 18.6679 15.0201 18.4777 15.0201 16.6042C15.0201 15.4556 15.8965 14.6526 17.3724 14.4388V13.5559H18.9576V14.4426C19.6427 14.5607 20.5468 14.8534 21.051 15.8646L21.118 15.9984L19.7641 16.6125L19.6956 16.5008C19.4585 16.117 18.7611 15.8157 18.1088 15.8157C17.6689 15.8157 16.6459 15.8927 16.6459 16.6041C16.6459 17.1155 17.305 17.2332 18.1672 17.3345C19.5152 17.4972 21.3604 17.7201 21.3604 19.6661C21.3604 21.0983 20.1758 21.8522 18.958 21.9858V22.9927H17.373V22.0342C16.0942 21.8867 15.154 21.2599 14.7185 20.2606Z"
                    fill="#10294F"
                  />
                </svg> */}
                5
              </div>
              <div className="title">{__("Regular Promos")}</div>
              <div className="dsc">
                {__(
                  "Tasty Tuesday, Free Spins Thursday, Cashback on a Monday – you are never far from a great promotion at Blizz!"
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="cashback_area_game_list d-none">
        <div className="container">
          <div className="cashback_area_game_headline">
            <div className="heading_cashback"> {__("Games")}</div>
            <Link to="#" className="view_more_cashback">
              {__("View all")}
            </Link>
          </div>
          <div className="cashback_games">
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-1.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-2.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-3.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-4.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-5.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>

            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-6.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
          </div>
        </div>
      </section>
      <section className="destiny_banner">
        <div className="container">
          <div className="banner_main">
            <img src={require("../assets/images/cashback/destiny-banner.png").default} />
            <div className="text_box">
              <div className="title">{__("All the Newest Games")}</div>
              <div className="dsc">
                {__(
                  "Unlike some other sites, we release new titles on the day they get released – from all the top providers! Check out the New section and our New Games Friday Newsletter for all the latest details!"
                )}
                {/* <br />
                {__("maecenas quis semper at nec tincidunt nunc.")} */}
              </div>
              {/* <div className="banner_btn">
                <Link>{__("Play game")}</Link>
              </div> */}

              {props.isAuthenticated ? (
                <Link to="/games/live-casino" className="common_btn_v1 large ">
                  {__("Play game")}
                </Link>
              ) : (
                <>
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="common_btn_v1 large "
                  >
                    {__("Play game")}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="cashback_area_game_list d-none">
        <div className="container">
          <div className="cashback_area_game_headline">
            <div className="heading_cashback"> {__("Games")}</div>
            <Link to="#" className="view_more_cashback">
              {__("View all")}
            </Link>
          </div>
          <div className="cashback_games">
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-1.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-2.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-3.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-4.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-5.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>

            <Link to="#" className="cashback_single_game">
              <div className="game_thumb">
                <img src={require("../assets/images/cashback/thumb-6.png").default} />
              </div>
              <div className="title">{__("Sweet Bonanza")}</div>
              <div className="dsc">{__("PRAGMATIC PLAY")}</div>
            </Link>
          </div>
        </div>
      </section>

      <section className="weekly_banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="title">{__("Weekly Cashback")}</div>
              <div className="dsc">
                {__(
                  "You will win even when you don’t here at Blizz with a great 2nd chance to win – every week! Finish the week $250 or more behind, and come Monday you will get 10% cashback on your previous weeks play – with no limit on the amount you could receive! It is cold, hard cash so you can play any game/s you want with it or cash out, subject to the minimum cashout amount – the choice is yours!"
                )}
              </div>
            </div>

            <div className="col-lg-5">
              <div className="banner_thumb">
                <img src={require("../assets/images/cashback/weekly-thumb1.png").default} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="destiny_banner">
        <div className="container">
          <div className="banner_main">
            <img src={require("../assets/images/cashback/mystry-banner.png").default} />
            <div className="text_box">
              <div className="title">{__("Follow us on Social Media")}</div>
              <div className="dsc">
                {__("Did you know we run great social only promotions? Like us on Facebook at")}{" "}
                <a
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="landingLink"
                  href="https://www.facebook.com/blizzcasino"
                >
                  {__("www.facebook.com/blizzcasino")}
                </a>{" "}
                {__("and on Telegram at")}{" "}
                <a
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="landingLink"
                  href="https://t.me/s/blizzcrypto"
                >
                  {__("https://t.me/s/blizzcrypto")}
                </a>{" "}
                {__("for some great and unique offers.")}
                {/* <br />
                {__("maecenas quis semper at nec tincidunt nunc.")} */}
              </div>
              {/* <div className="banner_btn"> */}
              {/* <Link className="common_btn_v1 large ">{__("Play game")}</Link> */}
              {/* </div> */}

              {props.isAuthenticated ? (
                <Link to="/games/live-casino" className="common_btn_v1 large ">
                  {__("Play game")}
                </Link>
              ) : (
                <>
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="common_btn_v1 large "
                  >
                    {__("Play game")}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="weekly_banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="banner_thumb">
                <img src={require("../assets/images/cashback/various-banner.png").default} />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="title">{__("Blizz Crypto Casino")}</div>
              <div className="dsc">
                {__(
                  "Blizz is THE best Crypto casino around with over 5,000 games to choose from with more being added each week from all the major providers. We have 10 great crypto currencies to choose from when you deposit and withdraw, you can also add funds with card or bank transfer if you prefer. We speak your language too with the site translated into 7 languages including English and more to come. Why else should you play at Blizz?"
                )}
              </div>
            </div>
          </div>
          <div className="feature_list">
            <div className="item">
              <div className="icon">1</div>
              <div className="title">{__("Great Welcome Package")}</div>
              <div className="dsc_block">
                {__("Get 100% up to 1 BTC on your 1st deposit and 50% up to 1.2 BTC on your 2nd")}
              </div>
            </div>
            <div className="item">
              <div className="icon">2</div>
              <div className="title">{__("Promotions")}</div>
              <div className="dsc_block">
                {__(
                  "Tasty Tuesday giving you 75% extra, Free Spins Thursday, Weekly Cashback, Monthly Races and plenty more ad-hoc promos"
                )}
              </div>
            </div>
            <div className="item">
              <div className="icon">3</div>
              <div className="title">{__("Fast Withdrawals")}</div>
              <div className="dsc_block">
                {__(
                  "Your money reaches us fast so we feel it is only right your money reaches you fast when you withdraw as well"
                )}
              </div>
            </div>

            <div className="item">
              <div className="icon">4</div>
              <div className="title">{__("Loyalty/VIP Scheme")}</div>
              <div className="dsc_block">
                {__(
                  "We run the best VIP scheme around, if you are a VIP at another crypto site, contact us with what you get and we will do our best to beat it"
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="slot_banner">
        <img src={require("../assets/images/cashback/slot-banner.png").default} />
        <div className="text_box">
          <div className="title">{__("Play at Blizz Crypto Casino")}</div>
          <div className="title colored">{__("When you have tried us, you won’t want to play anywhere else!")}</div>
          <div className="dsc">
            {__(
              "Great promotions, a huge selection of games including all the new releases on the day they come out, quick and easy deposits and withdrawals, 24/7 support and plenty more besides – launched in 2022, Blizz is quickly becoming the place to play in 2023 and beyond!"
            )}
          </div>
          {/* <div className="banner_btn">
            <Link>{__("Play game")}</Link>
          </div> */}
          {props.isAuthenticated ? (
            <Link to="/games/live-casino" className="common_btn_v1 large ">
              {__("Play game")}
            </Link>
          ) : (
            <>
              <Link
                to=""
                onClick={() => {
                  props.setModalSignUpPropsData(true);
                  setTimeout(function () {
                    props.setModalSignUpPropsData(false);
                  }, 500);
                }}
                className="common_btn_v1 large "
              >
                {__("Play game")}
              </Link>
            </>
          )}
        </div>
      </section>
      <section className="bottom_block">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 offset-xl-1">
              <div className="items">
                <div className="item">
                  <div className="icon">
                    <img src={require("../assets/images/cashback/power.svg").default} />
                  </div>
                  <div className="title">{__("Lightning Quick Withdrawals")}</div>
                  <div className="dsc">
                    {__(
                      "We pride ourselves on the speed of our withdrawals, any money you win is yours and we will get it back to you as soon as we possibly can!"
                    )}
                  </div>
                </div>
                <div className="item">
                  <div className="icon">
                    <img src={require("../assets/images/cashback/folder.svg").default} />
                  </div>
                  <div className="title">{__("Many Deposit Options")}</div>
                  <div className="dsc">
                    {__(
                      "Deposit and Withdraw with 10 Crypto coins including BTC, ETH, LTC, USDTE, USDTT, TRX, BNB and more – Card and Bank Transfer options available for deposits too"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
